import React, {Component} from 'react';
import {Col} from 'react-bootstrap';
import moment from 'moment/moment';

class MessageDate extends Component {
  render() {
    const {message} = this.props;
    const createdAt = moment(message.attributes['created-at'])
      .format('DD/MM/YYYY');
    return (
      <Col xs={11} sm={2}>
        {createdAt}
      </Col>
    );
  }
}

export default MessageDate;



// WEBPACK FOOTER //
// ./src/components/my-messages/message-date.jsx